import { Injectable,Injector } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http'
import { Observable } from 'rxjs';
import { CommonService } from '../app/common.service';
@Injectable({
  providedIn: 'root'
})
export class TokenInterceptorService implements HttpInterceptor {

  constructor(private injector:Injector) { }
  intercept(req, next) {
    let commonService=this.injector.get(CommonService)
    const token = commonService.getToken();
    if (!token) {
      return next.handle(req);
    }

    let tokenizedReq = req.clone({
      setHeaders:{
        Authorization:`Bearer ${token}`
      }
    })
    return next.handle(tokenizedReq)
  }
}
